<div *ngIf="widgetHasTooltip">
  <a class="widget-tooltip-icon" href="#" tabindex="-1" (click)="toggle( $event )" (blur)="hide()">
    <span class="glyphicon glyphicon-info-sign"></span>
  </a>
  <div class="popover bottom" [class.show]="visible" (click)="$event.stopPropagation()" (mousedown)="$event.preventDefault()">
    <div class="arrow"></div>
    <h4 *ngIf="tooltip.title" class="popover-title">{{ tooltip.title }}</h4>
    <div class="popover-content" [innerHtml]="tooltip.body"></div>
  </div>
</div>



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/tooltip.component.html